module.exports = __webpack_public_path__ + "王毅-c9f7fcd7.png";